require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-nbo-4-m.json") })
        }
      }, "path---photos-professional-nbo-4-m");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-nbo-4-m!./.cache/json/photos-professional-nbo-4-m.json
// module id = 841
// module chunks = 231608221292675